// extracted by mini-css-extract-plugin
module.exports = {"titleAndIconContainer":"AtShowMoreSection_titleAndIconContainer__1dPRC","titleIcon":"AtShowMoreSection_titleIcon__1LeGm","title":"AtShowMoreSection_title__5ACD2"};